import Tabs from "components/lib/Shared/Tabs";
import { Constants } from "config/constants";
import { ManageModuleContext } from "context/ManageCompanyModuleContext";
import ManualTransactionEditContext from "context/ManualTransactionEditContext";
import ManualTransactionReviewContext from "context/ManualTransactionReviewContext";
import UpdateHistoryContext from "context/UpdateHistoryContext";
import { useContext, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import {
  createBatchNumber,
  resetBatchNumber,
  setBatchNumber,
} from "state/slices/batchNumber";
import {
  getAllInitiateTransactionChangeAsync,
  getTransactionChangeByBatchNumberAsync,
  resetTransactionChange,
} from "state/slices/initiateTransactionChange";
import { handleCompanyMaintenanceFormData } from "utils/transactionRequestHandler";
import ApplicantDetails from "./ApplicantDetails";
import Approvals from "./Approvals";
import BRSForms from "./BRSForms";
import BeneficialOwners from "./BeneficialOwners";
import ChangeType from "./ChangeType";
import RegisteredAddress from "./RegisteredAddress";
import ShareInformation from "./ShareInformation";
import StakeholderDetails from "./StakeholderDetails";
import Status from "./Status";
import Summary from "./Summary";

const HistoryUpdate = ({
  dateFrom,
  dateTo,
  setActiveYearIndex,
  activeYearIndex,
  checkedTabs,
  setCheckedTabs,
  selectionsMade,
  setSelectionsMade,
  transactions,
  setTransactions,
  isHistoryTransactionTab,
  setAddOtherChanges,
  disableForm,
  yearTabs,
}) => {
  let initialTabs = [
    {
      id: "applicantDetails",
      label: "Applicant Details",
    },
    {
      id: "changeType",
      label: "Change Type",
    },
    {
      id: "summary",
      label: "Summary",
    },
    {
      id: "registeredAddress",
      label: "Registered Address",
    },
    {
      id: "shareInformation",
      label: "Share Information",
    },
    {
      id: "stakeholderDetails",
      label: "Stakeholder Details",
    },
    {
      id: "beneficialOwners",
      label: "Beneficial Owners",
    },
    {
      id: "approvals",
      label: "Approvals",
      //disable approvals tab if there are no transactions
      disabled: transactions.length === 0,
    },
    {
      id: "brsForms",
      label: "BRS Forms",
      //disable brs forms tab if there are no transactions
      disabled: transactions.length === 0,
    },
    {
      id: "status",
      label: "Status",
      //disable status tab if there are no transactions
      disabled: transactions.length === 0,
    },
  ];
  const { batchNo } = useSelector((state) => state.batchNumberSlice);
  const { company } = useSelector((state) => state.companyDashboardSlice);
  const { dateTo: To, dateFrom: From } = useSelector(
    (state) => state.transferYourBusinessSlice
  );

  const { isInManualTransactionReviewContext } = useContext(
    ManualTransactionReviewContext
  );
  const {
    transactionToEdit,
    setRefechTransactionOnEditContext,
    isInManualTransactionEditContext,
    setTransactionToEdit,
  } = useContext(ManualTransactionEditContext);

  const { companyId } = useParams();
  const location = useLocation();
  const dispatch = useDispatch();

  const manualTransactionReviewTabs = initialTabs;
  const [tabs, setTabs] = useState(
    isInManualTransactionReviewContext
      ? manualTransactionReviewTabs
      : initialTabs.slice(0, 2)
  );
  // const [checkedTabs, setCheckedTabs] = useState([]);
  // const [selectionsMade, setSelectionsMade] = useState({});
  const [selectedTab, setSelectedTab] = useState(tabs[0]);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [summarySubTabIndex, setSummarySubTabIndex] = useState(0);
  const [isStrikeOffSelected, setIsStrikeOffSelected] = useState(false);
  const [isConversionSelected, setIsConversionSelected] = useState(false);
  const [agreeToSubmit, setAgreeToSubmit] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [disableSubmitBtn, setDisableSubmitBtn] = useState(true);
  const [createdTransactionsIds, setCreatedTransactionsIds] = useState([]);
  // const [transactions, setTransactions] = useState([]);
  const [refechTransactionsOnUpdate, setRefechTransactionsOnUpdate] =
    useState(false);
  const [selectionErrors, setSelectionErrors] = useState([]);

  //FileName of template articles to be deleted from aws for gornance summary
  const [fileNameToDelete, setFileNameToDelete] = useState("");

  const { comments } = useSelector((state) => state.commentsSlice);
  let unresolvedComments = comments.filter((comment) => !comment.isResolved);
  const submitToLabel =
    unresolvedComments.length !== 0 ? "applicant" : "Next Step";

  // Parse URL query parameters to get the desired tab
  const queryParams = new URLSearchParams(location.search);
  const desiredTab = queryParams.get("tab");

  const noApprovalSelections = useMemo(() => {
    const allSelections = [];

    // Add specific selections from selectionsMade
    if (selectionsMade?.summary?.companyChanges) {
      allSelections.push(...selectionsMade.summary.companyChanges);
    }
    if (selectionsMade?.summary?.securities) {
      allSelections.push(...selectionsMade.summary.securities);
    }
    if (selectionsMade?.summary?.annualCompliance) {
      allSelections.push(...selectionsMade.summary.annualCompliance);
    }

    if (selectionsMade?.stakeholderDetails?.changeOfParticulars) {
      allSelections.push(
        ...selectionsMade.stakeholderDetails.changeOfParticulars
      );
    }

    return allSelections;
  }, [selectionsMade]);

  const includeApprovalTabs = () => {
    if (noApprovalSelections.length === 1) {
      return ![
        "Administrator",
        "annualReturns",
        "debentureAndChargesDischarge",
        "noticeToCancelConversionPVTtoPLC",
        "noticeToCancelConversionPLCtoPVT",
        ,
      ].includes(noApprovalSelections[0]);
    } else if (noApprovalSelections.length > 1) {
      const comparisonArray = [
        "Administrator",
        "annualReturns",
        "debentureAndChargesDischarge",
        "noticeToCancelConversionPVTtoPLC",
        "noticeToCancelConversionPLCtoPVT",
        ,
      ];
      return !noApprovalSelections.every((item) =>
        comparisonArray.includes(item)
      );
    } else {
      return true;
    }
  };

  // Callback to update parent tabs based on checkedTabs from ChangeType
  const updateParentTabs = () => {
    let newTabs = [
      ...initialTabs.slice(0, 2), // Keep applicantDetails and changeType
      ...initialTabs.filter((tab) => checkedTabs?.includes(tab?.id)), // Add checked tabs
    ];

    const shareInformation = selectionsMade?.shareInformation;

    const shareInfoToIncludeStakeholders = () => {
      if (shareInformation) {
        let capitalIncrease = shareInformation?.capitalIncrease;
        let capitalReduction = shareInformation?.capitalReduction;
        let sharesManagement = shareInformation?.sharesManagement;
        let shareholdingChanges = shareInformation?.shareholdingChanges;
        return (
          capitalIncrease?.includes("privateWithMoreThanOneClass") ||
          capitalIncrease?.includes("PVTwithOneClass") ||
          capitalIncrease?.includes("existingAuth") ||
          capitalIncrease?.includes("unallotedShares") ||
          capitalReduction?.length > 0 ||
          sharesManagement?.includes("sharesConsolidation") ||
          sharesManagement?.includes("sharesSubDivision") ||
          shareholdingChanges?.length > 0
        );
      }
    };

    if (
      shareInfoToIncludeStakeholders() &&
      !newTabs.includes({
        id: "stakeholderDetails",
        label: "Stakeholder Details",
      })
    ) {
      newTabs = [
        ...newTabs,
        ...initialTabs.filter((tab) => tab?.id === "stakeholderDetails"),
      ];
    }

    if (
      shareInfoToIncludeStakeholders() &&
      !newTabs.includes({
        id: "beneficialOwners",
        label: "Beneficial Owners",
      })
    ) {
      newTabs = [
        ...newTabs,
        ...initialTabs.filter((tab) => tab?.id === "beneficialOwners"),
      ];
    }

    // Only include default tabs (approvals, brsForms, status) if checkedTabs is non-empty
    if (checkedTabs.length > 0) {
      newTabs = [...newTabs, ...initialTabs.slice(7, 10)];
    }

    if (!includeApprovalTabs()) {
      newTabs = [...newTabs.filter((tab) => tab?.id !== "approvals")];
    }

    let filteredTabs = [];
    newTabs.forEach((tab) => {
      if (!filteredTabs.includes(tab)) {
        filteredTabs.push(tab);
      }
    });

    setTabs(filteredTabs);

    // Set the selected tab to the first checked tab (after applicantDetails and changeType)

    if (isHistoryTransactionTab) {
      setSelectedTabIndex(1);
      setSelectedTab(filteredTabs[1] || tabs[1]);
      setSummarySubTabIndex(0);
    } else {
      setSelectedTabIndex(2);
      setSelectedTab(filteredTabs[2] || tabs[2]);
      setSummarySubTabIndex(0);
    }
  };

  // Callback to remove a specific tab from parent tabs when deselected in ChangeType
  const removeParentTab = (tabId) => {
    let newTabs = tabs.filter((tab) => tab.id !== tabId);

    // If checkedTabs is empty, ensure default tabs are removed
    if (checkedTabs.length === 1 && checkedTabs.includes(tabId)) {
      newTabs = initialTabs.slice(0, 2); // Reset to only applicantDetails and changeType
    }

    setTabs(newTabs);
    if (selectedTab.id === tabId) {
      const newIndex = Math.min(selectedTabIndex, newTabs.length - 1);
      setSelectedTabIndex(newIndex);
      setSelectedTab(newTabs[newIndex] || newTabs[0]);
      setSummarySubTabIndex(0);
    }
  };

  //function to handle selections when on edit mode
  const getAllSelectionsArray = (selectionsMade) => {
    if (!selectionsMade || typeof selectionsMade !== "object") return [];
    return Object.values(selectionsMade)
      .flatMap((section) =>
        section && typeof section === "object"
          ? Object.values(section).flat()
          : []
      )
      .filter(Boolean);
  };

  let selections = useMemo(() => {
    return getAllSelectionsArray(selectionsMade);
  }, [selectionsMade]);

  if (transactionToEdit) {
    useEffect(() => {
      if (
        noApprovalSelections?.length > 0 &&
        selections?.length === 1 &&
        !includeApprovalTabs()
      ) {
        updateParentTabs();
      }
    }, [noApprovalSelections, selections]);
  }

  useEffect(() => {
    if (desiredTab) {
      const tabIndex = tabs.findIndex((tab) => tab.id === desiredTab);
      if (tabIndex !== -1) {
        setSelectedTabIndex(tabIndex);
      }
    }
  }, [desiredTab, noApprovalSelections, tabs]);

  useEffect(() => {
    setSelectedTab(tabs[selectedTabIndex]);
  }, [selectedTabIndex, tabs]);

  useEffect(() => {
    if (From && To) {
      setSelectedTabIndex(0);
    }
  }, [From, To]);

  const handleBackToChangesDashboard = () => {
    setshowRecentChanges(false);
    setselectedProcess("");
  };

  transactionEditTabs({
    setCheckedTabs,
    checkedTabs,
    setSelectionsMade,
    setTabs,
    setSelectedTabIndex,
    setIsStrikeOffSelected,
    setIsConversionSelected,
    company,
    transactions,
    initialTabs,
  });

  const { handleBackToManageYourCompanyDashboard } =
    useContext(ManageModuleContext);

  const handleGoBack = () => {
    setSelectedTabIndex(selectedTabIndex - 1);
    setSummarySubTabIndex(0);
  };

  const handleGoForward = () => {
    setSelectedTabIndex(selectedTabIndex + 1);
    setSummarySubTabIndex(0);
  };

  const isInUpdateHistoryContext = true;

  //*! Utility Functions for createdTransactionsIds and transactionEdit Operations
  // 1. Add Unique Transaction ID
  const addUniqueTransactionId = (id) => {
    setCreatedTransactionsIds((prev) => [...prev, id]);
  };
  // 2. Remove Transaction ID
  const removeTransactionId = (id) => {
    setCreatedTransactionsIds((prev) =>
      prev.filter((existingId) => existingId !== id)
    );
  };
  // 3. Function to check if a transaction already exists
  const transactionExists = (changeType) => {
    for (const transaction of transactions) {
      if (transaction.changeType === changeType) {
        return transaction;
      }
    }
    return false;
  };

  useEffect(() => {
    if (
      transactionToEdit?._id &&
      !createdTransactionsIds.includes(transactionToEdit._id)
    ) {
      addUniqueTransactionId(transactionToEdit._id);
    }
  }, [transactionToEdit?._id, createdTransactionsIds]);

  const mergeTransactions = (current, incoming) => {
    const map = new Map();

    // Keep existing
    current?.forEach((t) => map.set(t?._id, t));

    //  add incoming
    incoming?.forEach((t) => map.set(t?._id, t));

    return Array.from(map.values());
  };

  useEffect(async () => {
    if (transactionToEdit?.batchNo) {
      dispatch(setBatchNumber(transactionToEdit?.batchNo));
      const result = await dispatch(
        getTransactionChangeByBatchNumberAsync({
          batchNo: transactionToEdit?.batchNo,
        })
      );
      if (result?.payload?.items?.length > 0) {
        setTransactions((prev) =>
          mergeTransactions(prev, result.payload.items)
        );
      }
    } else {
      const selectedOptions = Object.keys(selectionsMade)
        .map((key) => {
          return Object.keys(selectionsMade[key]).filter(Boolean);
        })
        .map((array) => array.filter(Boolean))
        .flat();

      if (
        (createdTransactionsIds.length > 1 || selectedOptions.length > 1) &&
        !batchNo
      ) {
        dispatch(createBatchNumber());
      } else if (createdTransactionsIds.length === 1 && batchNo) {
        dispatch(resetBatchNumber());
      }
    }
  }, [createdTransactionsIds, transactionToEdit?._id]);

  useEffect(() => {
    createdTransactionsIds.forEach(async (trxId) => {
      const result = await handleCompanyMaintenanceFormData(
        "existing-request",
        {
          documentId: trxId,
          batchNo,
        },
        companyId
      );
    });
  }, [batchNo, createdTransactionsIds]);

  useEffect(() => {
    const fetchTransactions = async () => {
      if (createdTransactionsIds.length > 0) {
        const result = await dispatch(
          getAllInitiateTransactionChangeAsync({
            companyId,
            params: {
              transactionType: Constants.TRANSACTION_TYPES.MANUAL,
              transactionIds: createdTransactionsIds.filter((id) =>
                Boolean(id)
              ),
              ...(batchNo && { batchNo: batchNo }),
            },
          })
        );

        ///on refech transactions on update
        if (refechTransactionsOnUpdate && isInManualTransactionEditContext) {
          setRefechTransactionOnEditContext(true);
        }

        if (result?.payload?.items?.length > 0) {
          setTransactions(result.payload.items);
        }
        // Reset the refetch flag so subsequent calls can toggle it again.
        if (refechTransactionsOnUpdate) {
          setRefechTransactionsOnUpdate(false);
        }

        //refech transactions
        dispatch(
          getAllInitiateTransactionChangeAsync({
            companyId: company?._id,
            params: {
              limit: null,
              skip: 0,
              search: "",
              sort: "updatedAt",
              order: "desc",
            },
          })
        );
      } else {
        dispatch(resetTransactionChange());
      }
    };

    fetchTransactions();
  }, [createdTransactionsIds, refechTransactionsOnUpdate]);

  return (
    <UpdateHistoryContext.Provider
      value={{
        isInUpdateHistoryContext,
        checkedTabs,
        setCheckedTabs,
        selectionsMade,
        setSelectionsMade,
        isStrikeOffSelected,
        setIsStrikeOffSelected,
        createdTransactionsIds,
        setCreatedTransactionsIds,
        handleGoBack,
        handleGoForward,
        transactions,
        setTransactions,
        addUniqueTransactionId,
        transactionExists,
        fileNameToDelete,
        setFileNameToDelete,
        setRefechTransactionsOnUpdate,
        refechTransactionsOnUpdate,
        selectionErrors,
        setSelectionErrors,
        isConversionSelected,
        setIsConversionSelected,
        dateFrom,
        dateTo,
        setSelectedTabIndex,
        disableForm,
        yearTabs,
        activeYearIndex,
      }}
    >
      <div>
        <div>
          <Tabs
            tabs={tabs}
            selectedTabIndex={selectedTabIndex}
            setSelectedTabIndex={setSelectedTabIndex}
            tabsClickable={false}
          />
        </div>

        <div className="pt-4">
          {selectedTab?.id === "applicantDetails" && (
            <ApplicantDetails
              handleGoForward={handleGoForward}
              setActiveYearIndex={setActiveYearIndex}
              activeYearIndex={activeYearIndex}
            />
          )}
          {selectedTab?.id === "changeType" && (
            <ChangeType
              handleGoBack={handleGoBack}
              updateParentTabs={updateParentTabs}
              removeParentTab={removeParentTab}
              setTab={setSelectedTabIndex}
            />
          )}
          {selectedTab?.id === "summary" && (
            <Summary
              summarySubTabIndex={summarySubTabIndex}
              setSummarySubTabIndex={setSummarySubTabIndex}
              handleGoBack={handleGoBack}
              handleGoForward={handleGoForward}
            />
          )}
          {selectedTab?.id === "registeredAddress" && (
            <RegisteredAddress
              handleGoBack={handleGoBack}
              handleGoForward={handleGoForward}
            />
          )}
          {selectedTab?.id === "shareInformation" && (
            <ShareInformation
              handleGoBack={handleGoBack}
              handleGoForward={handleGoForward}
            />
          )}
          {selectedTab?.id === "stakeholderDetails" && (
            <StakeholderDetails
              handleGoBack={handleGoBack}
              handleGoForward={handleGoForward}
            />
          )}
          {selectedTab?.id === "beneficialOwners" && (
            <BeneficialOwners
              handleGoBack={handleGoBack}
              handleGoForward={handleGoForward}
            />
          )}
          {selectedTab?.id === "approvals" && (
            <Approvals
              handleGoBack={handleGoBack}
              handleGoForward={handleGoForward}
            />
          )}
          {selectedTab?.id === "brsForms" && (
            <BRSForms
              handleGoBack={handleGoBack}
              handleGoForward={handleGoForward}
            />
          )}
          {selectedTab?.id === "status" && (
            <Status
              submitToLabel={submitToLabel}
              setDisableSubmitBtn={setDisableSubmitBtn}
              agreeToSubmit={agreeToSubmit}
              agreeToTerms={agreeToTerms}
              setAgreeToSubmit={setAgreeToSubmit}
              setAgreeToTerms={setAgreeToTerms}
              handleGoBack={handleGoBack}
              setActiveYearIndex={setActiveYearIndex}
              setAddOtherChanges={setAddOtherChanges}
            />
          )}
        </div>
      </div>
    </UpdateHistoryContext.Provider>
  );
};

export default HistoryUpdate;

function transactionEditTabs({
  setCheckedTabs,
  checkedTabs,
  setSelectionsMade,
  setTabs,
  setSelectedTabIndex,
  setIsStrikeOffSelected,
  setIsConversionSelected,
  company,
  transactions,
  initialTabs,
}) {
  useEffect(() => {
    if (!transactions?.length) {
      setTabs(initialTabs.slice(0, 2));
      return;
    }

    const isPLC = company?.type === "PLC";

    // Base tabs — added once
    const tabMap = new Map();
    const addTab = (id, label) => {
      if (!tabMap.has(id)) {
        tabMap.set(id, { id, label });
      }
    };

    // Always present
    addTab("applicantDetails", "Applicant Details");
    addTab("changeType", "Change Type");

    // We'll collect checked tabs and selections progressively
    let nextCheckedTabs = [...checkedTabs];
    const addChecked = (tabId) => {
      if (!nextCheckedTabs.includes(tabId)) {
        nextCheckedTabs.push(tabId);
      }
    };

    transactions.forEach((tx) => {
      if (!tx) return;
      const { changeType, applicationType } = tx;

      // Summary tab + related logic
      const summaryTypes = [
        Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_NAME,
        Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_FY,
        Constants.TRANSACTION_CHANGE_TYPES.STRIKE_OFF,
        Constants.TRANSACTION_CHANGE_TYPES.CONVERSION,
        Constants.TRANSACTION_CHANGE_TYPES.YYYY_ANNUAL_RETURNS,
        Constants.TRANSACTION_CHANGE_TYPES.YYYY_FINANCIAL_STATEMENTS,
        Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_ARTICLES,
        Constants.TRANSACTION_CHANGE_TYPES.NOTICE_TO_CANCEL_CONVERSION,
        Constants.TRANSACTION_CHANGE_TYPES.NOTICE_OF_WITHDRAWAL_OF_STRIKE_OFF,
        Constants.TRANSACTION_CHANGE_TYPES.ADMINISTRATIVE_RESTORATION,
      ];

      if (summaryTypes.includes(changeType)) {
        addTab("summary", "Summary");
        addChecked("summary");

        setSelectionsMade((prev) => {
          const summary = {
            ...prev.summary,
            companyChanges: prev.summary?.companyChanges ?? [],
            annualCompliance: prev.summary?.annualCompliance ?? [],
            governanceChanges: prev.summary?.governanceChanges ?? [],
          };

          const companyChangesSet = new Set(summary.companyChanges);
          const annualComplianceSet = new Set(summary.annualCompliance);

          if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_NAME
          ) {
            companyChangesSet.add("changeOfCompanyName");
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_FY
          ) {
            companyChangesSet.add("accountingReferenceDate");
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.STRIKE_OFF
          ) {
            companyChangesSet.add("strikeOffApplication");
            setIsStrikeOffSelected(true);
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.CONVERSION
          ) {
            const key = isPLC ? "conversionPLCtoPVT" : "conversionPVTtoPLC";
            companyChangesSet.add(key);
            setIsConversionSelected(true);
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.YYYY_ANNUAL_RETURNS
          ) {
            annualComplianceSet.add("annualReturns");
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.YYYY_FINANCIAL_STATEMENTS
          ) {
            annualComplianceSet.add("financialStatements");
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_ARTICLES
          ) {
            summary.governanceChanges = ["amendmentOfArticles"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.NOTICE_TO_CANCEL_CONVERSION
          ) {
            const key = isPLC
              ? "noticeToCancelConversionPLCtoPVT"
              : "noticeToCancelConversionPVTtoPLC";
            companyChangesSet.add(key);
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES
              .NOTICE_OF_WITHDRAWAL_OF_STRIKE_OFF
          ) {
            companyChangesSet.add("noticeOfWithdrawalOfStrikeOffApplication");
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.ADMINISTRATIVE_RESTORATION
          ) {
            companyChangesSet.add("applicationForAdministrativeRestoration");
          }

          summary.companyChanges = Array.from(companyChangesSet);
          summary.annualCompliance = Array.from(annualComplianceSet);

          return { ...prev, summary };
        });
      }

      // Registered Address
      if (
        changeType ===
        Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_REGISTERED_ADDRESS
      ) {
        addTab("registeredAddress", "Registered Address");
        addChecked("registeredAddress");

        setSelectionsMade((prev) => ({
          ...prev,
          registeredAddress: {
            ...prev.registeredAddress,
            changeOfAddress: ["changeOfRegisteredAddress"],
          },
        }));
      }

      // Share Capital related transactions
      if (
        applicationType ===
        Constants.TRANSACTION_APPLICATION_TYPES.SHARE_CAPITAL
      ) {
        addTab("shareInformation", "Share Information");
        addTab("stakeholderDetails", "Stakeholder Details");
        addTab("beneficialOwners", "Beneficial Owners");

        addChecked("shareInformation");

        setSelectionsMade((prev) => {
          const shareInfo = { ...prev.shareInformation };

          if (changeType === Constants.TRANSACTION_CHANGE_TYPES.ALLOTMENT) {
            shareInfo.capitalIncrease = ["PVTwithOneClass"]; // ← fix the || logic if needed
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.AUTHORIZATION
          ) {
            shareInfo.capitalIncrease = ["authorization"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.AUTHORIZATION_AND_ALLOTMENT
          ) {
            shareInfo.capitalIncrease = ["privateWithMoreThanOneClass"];
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.SHARE_TRANSFER
          ) {
            shareInfo.shareholdingChanges = ["shareTransfer"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.TRANSMISSION_OF_SHARES
          ) {
            shareInfo.shareholdingChanges = ["transferShares"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.FORFEITURE_OF_SHARES
          ) {
            shareInfo.shareholdingChanges = ["forfeitureOfShares"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.SURRENDER_OF_SHARES
          ) {
            shareInfo.shareholdingChanges = ["surrenderOfShares"];
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.SHARES_BUYBACK
          ) {
            shareInfo.shareholdingChanges = ["sharesBuyback"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.CANCELATION_OF_TREASURY_SHARES
          ) {
            shareInfo.shareholdingChanges = ["cancelationOfTreasuryShares"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.SALE_TRANSFER_OF_TREASURY_SHARES
          ) {
            shareInfo.shareholdingChanges = ["sale/TransferOfTreasuryShares"];
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.SHARES_REDEMPTION
          ) {
            shareInfo.shareholdingChanges = ["sharesRedemption"];
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.TAKEOVER_OFFER
          ) {
            shareInfo.shareholdingChanges = ["takeoverOffer"];
          } else if (
            changeType ===
            Constants.TRANSACTION_CHANGE_TYPES.SHARES_CONSOLIDATION
          ) {
            shareInfo.sharesManagement = ["sharesConsolidation"];
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.SHARES_SUBDIVISION
          ) {
            shareInfo.sharesManagement = ["sharesSubDivivsion"]; // ← typo? subdivision ?
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.SOLVENCY_STATEMENT
          ) {
            shareInfo.capitalReduction = ["solvencyStatement"];
          } else if (
            changeType === Constants.TRANSACTION_CHANGE_TYPES.COURT_ORDER
          ) {
            shareInfo.capitalReduction = ["courtOrder"];
          }

          return { ...prev, shareInformation: shareInfo };
        });
      }
      // Stakeholder changes
      if (changeType === Constants.TRANSACTION_CHANGE_TYPES.APPOINTMENT) {
        addTab("stakeholderDetails", "Stakeholder Details");
        addChecked("stakeholderDetails");

        setSelectionsMade((prev) => ({
          ...prev,
          stakeholderDetails: {
            ...prev.stakeholderDetails,
            appointment: [
              ...(prev.stakeholderDetails?.appointment || []),
              applicationType,
            ],
          },
        }));
      }

      if (changeType === Constants.TRANSACTION_CHANGE_TYPES.CESSATION) {
        addTab("stakeholderDetails", "Stakeholder Details");
        addChecked("stakeholderDetails");

        setSelectionsMade((prev) => ({
          ...prev,
          stakeholderDetails: {
            ...prev.stakeholderDetails,
            cessation: [
              ...(prev.stakeholderDetails?.cessation || []),
              applicationType,
            ],
          },
        }));
      }

      if (
        changeType === Constants.TRANSACTION_CHANGE_TYPES.CHANGE_OF_PARTICULARS
      ) {
        if (
          applicationType === Constants.APPLICANT_CAPACITIES.BENEFICIAL_OWNER
        ) {
          addTab("beneficialOwners", "Beneficial Owners");
          addChecked("beneficialOwners");

          setSelectionsMade((prev) => ({
            ...prev,
            beneficialOwners: {
              ...prev.beneficialOwners,
              changesBeneficialOwners: [
                ...(prev.beneficialOwners?.changesBeneficialOwners || []),
                applicationType,
              ],
            },
          }));
        } else {
          addTab("stakeholderDetails", "Stakeholder Details");
          addChecked("stakeholderDetails");

          setSelectionsMade((prev) => ({
            ...prev,
            stakeholderDetails: {
              ...prev.stakeholderDetails,
              changeOfParticulars: [
                ...(prev.stakeholderDetails?.changeOfParticulars || []),
                applicationType,
              ],
            },
          }));
        }
      }
    });

    // Final common tabs — added only once
    addTab("approvals", "Approvals");
    addTab("brsForms", "BRS Forms");
    addTab("status", "Status");

    // Convert map back to array (preserves insertion order)
    const finalTabs = initialTabs?.filter((tab) => tabMap.has(tab.id));

    setTabs(finalTabs);
    setCheckedTabs(nextCheckedTabs);
    // setSelectedTabIndex(1)
  }, [transactions]);
}
